import React from 'react';
import PropTypes from 'prop-types';
import { Link, Stack, mergeStyles } from '@bingads-webui-react/fabric-control';
import classNames from 'classnames';
import { Header, DefaultButton } from './components';

const descriptionStyles = mergeStyles({
  minHeight: 60,
  marginTop: 16,
  marginBottom: 12,
});

export const NotInterested = ({ i18n, onDismiss, couponDetailsUrl }) => (
  <div>
    <Header text={i18n.getString('Not_Interested_Title')} i18n={i18n} onCloseButtonClick={onDismiss} />
    <div className={classNames('coupon-description', descriptionStyles)}>
      {i18n.getString('Not_Interested_Description')}
      {' '}
      {couponDetailsUrl ? <Link href={couponDetailsUrl}>{i18n.getString('Coupon_Page')}</Link> : i18n.getString('Coupon_Page')}
    </div>
    <Stack horizontal horizontalAlign="end" verticalAlign="center">
      <DefaultButton text={i18n.getString('Button_Close')} onClick={onDismiss} className="close-button" />
    </Stack>
  </div>);

NotInterested.propTypes = {
  couponDetailsUrl: PropTypes.string.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  onDismiss: PropTypes.func.isRequired,
};
